import React from 'react';
import AddIcon from '@atlaskit/icon/core/add';
import ChangesIcon from '@atlaskit/icon/core/changes';
import EditIcon from '@atlaskit/icon/glyph/edit';
import DropdownMenu, { DropdownItem, DropdownItemGroup } from '@atlaskit/dropdown-menu';
import { SkeletonLoader, SkeletonLoaderWrapper } from '@css-xp/skeleton-loader';

export const AddToOrderActionsMenu = ({
  onTransferClick,
  onAddNewProductsClick,
  openUpdateExistingEntitlementModal,
  isLoading,
  onAddNewAppOrAddOnClick,
  isAddOnsPhase2Enabled,
  isAppificationEnabled,
}: {
  onTransferClick: () => void;
  onAddNewProductsClick: () => void;
  openUpdateExistingEntitlementModal: () => void;
  isLoading?: boolean;
  onAddNewAppOrAddOnClick: () => void;
  isAddOnsPhase2Enabled?: boolean;
  isAppificationEnabled?: boolean;
}) => {
  return isLoading ? (
    <SkeletonLoaderWrapper>
      <SkeletonLoader width="200px" />
    </SkeletonLoaderWrapper>
  ) : (
    <DropdownMenu trigger="Add to order" triggerType="button" testId="add-to-order-actions-menu">
      <DropdownItemGroup>
        <DropdownItem
          onClick={openUpdateExistingEntitlementModal}
          elemBefore={<EditIcon label="edit" size="small" />}
          triggerType="button"
        >
          Update existing
        </DropdownItem>
        {isAddOnsPhase2Enabled && (
          <DropdownItem elemBefore={<AddIcon label="add" />} onClick={onAddNewAppOrAddOnClick}>
            {isAppificationEnabled ? 'Marketplace' : 'New'} app/add-on
          </DropdownItem>
        )}
        <DropdownItem elemBefore={<AddIcon label="add" />} onClick={onAddNewProductsClick}>
          New {isAppificationEnabled ? 'subscription' : 'product'}
        </DropdownItem>
        <DropdownItem elemBefore={<ChangesIcon label="transfer" />} onClick={onTransferClick}>
          Transfer
        </DropdownItem>
      </DropdownItemGroup>
    </DropdownMenu>
  );
};
